var _path, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallConfetti2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 261,
    viewBox: "0 0 198 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M115.644 160.853C113.328 161.708 111.294 163.257 109.232 165.52C109.75 162.69 109.631 160.262 108.752 157.974C107.825 155.558 106.083 153.388 103.56 151.1C107.062 151.769 109.897 151.694 112.378 150.733C114.373 149.96 116.068 148.641 117.666 146.811C117.212 149.285 117.317 151.454 118.092 153.498C119.015 155.931 120.849 158.077 123.561 160.314C120.536 159.864 117.987 159.988 115.644 160.853Z",
    stroke: "#007C6D",
    strokeWidth: 1.80952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 102.307,
    y: 258.142,
    width: 9.84196,
    height: 9.84196,
    transform: "rotate(167.283 102.307 258.142)",
    stroke: "#007C6D",
    strokeWidth: 0.904762
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.11046 141.548C6.08297 141.927 5.17823 142.603 4.26792 143.582C4.47679 142.346 4.41273 141.274 4.02351 140.26C3.61106 139.185 2.84843 138.219 1.7529 137.209C3.28863 137.487 4.54565 137.443 5.65151 137.015C6.52807 136.675 7.27748 136.106 7.98084 135.324C7.80223 136.398 7.86002 137.35 8.20133 138.25C8.61226 139.334 9.4164 140.291 10.5944 141.28C9.27369 141.099 8.14876 141.164 7.11046 141.548Z",
    stroke: "#007C6D",
    strokeWidth: 0.904762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M192.11 90.5476C191.083 90.9269 190.178 91.6034 189.268 92.582C189.477 91.3459 189.413 90.2736 189.024 89.2598C188.611 88.1855 187.848 87.2191 186.753 86.2093C188.289 86.4868 189.546 86.443 190.652 86.0145C191.528 85.6749 192.277 85.106 192.981 84.3241C192.802 85.3984 192.86 86.3502 193.201 87.2501C193.612 88.3337 194.416 89.291 195.594 90.28C194.274 90.0986 193.149 90.1643 192.11 90.5476Z",
    stroke: "#007C6D",
    strokeWidth: 0.904762,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5117 13.7513C85.9486 14.3283 84.5625 15.3183 83.1911 16.7174C83.4321 14.903 83.2943 13.2902 82.7043 11.7535C82.0736 10.1106 80.9515 8.62673 79.3725 7.10816C81.6459 7.45744 83.5551 7.34972 85.257 6.69037C86.5598 6.18561 87.6897 5.37722 88.7421 4.29138C88.5498 5.84696 88.6772 7.25787 89.1875 8.60356C89.8186 10.2677 91.005 11.7448 92.7061 13.2387C90.7734 13.0315 89.0853 13.1704 87.5117 13.7513Z",
    stroke: "#007C6D",
    strokeWidth: 1.80952,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallConfetti2);
export default __webpack_public_path__ + "static/media/small_confetti2.0d93caa00b2833c9031eecf1ac567334.svg";
export { ForwardRef as ReactComponent };